import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { toast } from "react-toastify";

const Visi = () => {
  const [visi, setVisi] = useState("");
  const [idVisi, setIdVisi] = useState("");
  const [titleVisi, setTitleVisi] = useState("");
  const [imageUrlVisi, setImageUrlVisi] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  /**
   * Fetch data visi
   */
  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const visionResponse = await axios.get(
        `/api_w/abouts?title=Visi&_t=${Date.now()}`,
        {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        }
      );

      const responseData = visionResponse?.data?.data || [];

      const vision = responseData.find(
        (item) => item.title?.toLowerCase() === "visi"
      );

      if (vision) {
        setIdVisi(vision.id || "");
        setTitleVisi(vision.title || "");
        setVisi(vision.body || "");
        setImageUrlVisi(vision.image_url || "");
      } else {
        setIdVisi("");
        setTitleVisi("");
        setVisi("");
        setImageUrlVisi("");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Ambil data saat pertama kali halaman dibuka
   */
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  /**
   * Ambil ulang data ketika kembali ke tab/browser
   */
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchData();
      }
    };

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );

    return () => {
      document.removeEventListener(
        "visibilitychange",
        handleVisibilityChange
      );
    };
  }, [fetchData]);

  /**
   * Edit visi
   */
  const handleEditClick = (id) => {
    navigate(`/admin/edit-visi/${id}`);
  };

  /**
   * Tambah visi
   */
  const handleAddClick = () => {
    navigate(`/admin/add-visi`);
  };

  /**
   * Render media
   */
  const renderMedia = (videoUrl) => {
    if (!videoUrl) return null;

    const youtubeMatch = videoUrl.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
    );

    const gdriveMatch = videoUrl.match(
      /drive\.google\.com\/file\/d\/([^\/]+)\//
    );

    let videoSrc = videoUrl;

    if (youtubeMatch) {
      videoSrc = `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    } else if (gdriveMatch) {
      videoSrc = `https://drive.google.com/file/d/${gdriveMatch[1]}/preview`;
    }

    return (
      <iframe
        className="aspect-video w-full"
        src={videoSrc}
        title="Video"
        frameBorder="0"
        allowFullScreen
      />
    );
  };

  return (
    <div className="mx-auto mt-5 p-5">
      {loading ? (
        <div className="flex justify-center py-10">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600" />
        </div>
      ) : (
        <>
          {!titleVisi && (
            <div className="mb-4">
              <button
                onClick={handleAddClick}
                className="rounded bg-blue-600 px-4 py-2 font-bold text-white"
              >
                Isi Data Visi
              </button>
            </div>
          )}

          {titleVisi && (
            <div className="relative mx-auto mb-4 w-full rounded-lg border border-gray-600 bg-gray-200 p-6">
              <h2 className="mb-4 flex items-center justify-center text-center text-xl font-bold uppercase">
                {titleVisi}
              </h2>

              {imageUrlVisi && (
                <div className="mb-4 flex justify-center">
                  {renderMedia(imageUrlVisi)}
                </div>
              )}

              <div className="break-words">
                {visi ? parse(visi) : null}
              </div>

              <FaEdit
                className="absolute right-2 top-2 h-5 w-5 cursor-pointer text-gray-800"
                onClick={() => handleEditClick(idVisi)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Visi;